import Header from './components/Header';
import Hero from './components/Hero';
import SobreEscola from './components/SobreEscola';
import Turmas from './components/Turmas';
import Metodologia from './components/Metodologia';
import Diferenciais from './components/Diferenciais';
import Galeria from './components/Galeria';
import CTAPrincipal from './components/CTAPrincipal';
import Contato from './components/Contato';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="font-body bg-white">
      <Header />
      <Hero />
      <SobreEscola />
      <Turmas />
      <Metodologia />
      <Diferenciais />
      <Galeria />
      <CTAPrincipal />
      <Contato />
      <Footer />
    </main>
  );
}
